<m-input-style class="m-integerfield"
               :disabled="isDisabled"
               :waiting="isWaiting"
               :error="hasDecimalfieldError"
               :valid="isDecimalfieldValid"
               :label="label"
               :label-for="id"
               :focus="isFocus"
               :label-up="labelUp"
               :empty="isEmpty"
               :readonly="isReadonly"
               :required-marker="requiredMarker"
               :tag-style="tagStyle"
               :error-message="errorMessage"
               :valid-message="validMessage"
               :helper-message="helperMessage"
               :style="{ width: inputWidth, maxWidth: inputMaxWidth }"
               @click="onClick">
    <slot name="prefix"
          slot="prefix" />
    <m-input-mask v-model="model"
                  ref="inputMask"
                  :id="id"
                  class="m-integerfield__input"
                  inputmode="decimal"
                  type="number"
                  :min="min"
                  :max="max"
                  :disabled="isDisabled"
                  :readonly="isReadonly || isWaiting"
                  :placeholder="placeholder"
                  :autocomplete="autocomplete"
                  :options="inputMaskOptions"
                  :aria-invalid="hasDecimalfieldError"
                  :aria-label="inputAriaLabel"
                  :aria-describedby="validationMessageId"
                  :required="required || requiredMarker"
                  @focus="onFocus"
                  @blur="onBlur"
                  @keyup="onKeyup"
                  @change="onChange" />
    <slot name="suffix"
          slot="suffix" />
    <div slot="validation"
         :id="validationMessageId"
         class="m-integerfield__validation">
        <m-validation-message class="m-integerfield__validation-message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasDecimalfieldError"
                              :error-message="errorMessage"
                              :valid="isDecimalfieldValid"
                              :valid-message="validMessage"
                              :helper-message="helperMessage" />
    </div>
</m-input-style>
